module.exports = "<svg width=\"25\" height=\"18\" viewBox=\"0 0 25 18\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.61 17.4c.78.825 2.09.836 2.882.02L23.645 3.88a1.99 1.99 0 0 0-.042-2.818 1.994 1.994 0 0 0-2.818.042L9.07 13.134 4.135 7.9a1.994 1.994 0 0 0-2.817-.086 1.99 1.99 0 0 0-.086 2.816l6.377 6.77z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeSVGTagAttrs=false&removeTags=true!./src/images/svg/widget-icons/solid2/nps.svg
// module id = ZDAe
// module chunks = 89